
export const filterJobs = (jobs, permission = {}, object_id = 'all') => {
  let result = []

  if(permission.available_jobs === null) {
    return jobs;
  }

  console.log(permission.available_jobs, object_id, 'permission.available_jobs, object_id')

  jobs.map((row) => {
    if (permission.available_jobs[object_id] && (permission.available_jobs[object_id].includes(row.id) || permission.available_jobs[object_id].includes(row.originalId))) {
      result.push(row);
    }
  });

  console.log(result, permission.available_jobs[object_id])
  return result;
}


export const filterObjects = (objects, permission = {}) => {
  let result = []
  if(!permission) {
    return objects;
  }

  console.log(permission, 'permission')

  if(permission.available_objects === null) {
    return objects;
  }

  objects.map((row) => {
    if (permission.available_objects.includes(row.id || row.value)) {
      result.push(row);
    }
  });

  return result;
}

export const filterFiles = (jobs, permission = {}, object_id = 'all') => {
  let result = []

  if(permission.available_files === null) {
    return jobs;
  }

  if(!object_id) {
    jobs.map((row) => {
      // console.log(permission.available_files[row._data.documentation[0]], row._data.documentation[0], row.id, permission.available_files[row._data.documentation[0]].includes(row.id), 'row._data.documentation[0]')
      if (row._data.documentation && permission.available_files[row._data.documentation] && permission.available_files[row._data.documentation[0]].includes(row.id)) {
        result.push(row);
      }
    });

    return result;
  }

  jobs.map((row) => {
    if (permission.available_files[object_id] && permission.available_files[object_id].includes(row.id)) {
      result.push(row);
    }
  });

  return result;
}


export const filterDocs = (objects, permission = {}) => {
  let result = []

  if(permission.available_docs === null) {
    return objects;
  }

  objects.map((row) => {
    if (permission.available_docs.includes(row.id)) {
      result.push(row);
    }
  });

  return result;
}



// WEBPACK FOOTER //
// ./src/utils/filterJobs.js